// src/hooks/usePlatformConfig.js
import { useState, useEffect } from "react";

const usePlatformConfig = (baseConfigPath) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = window.matchMedia("(max-width: 768px)").matches;
      setIsMobile(isMobileDevice);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!baseConfigPath) {
      setError("No configPath provided");
      return;
    }

    const configPath = isMobile
      ? baseConfigPath.replace(".json", "_mobile.json")
      : baseConfigPath;

    fetch(configPath)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Fetch failed: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setConfig(data);
        setError(null);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError(err.message);
      });
  }, [baseConfigPath, isMobile]);

  return { config, error, isMobile };
};

export default usePlatformConfig;
